import { comments, first_name, last_name, id } from "../common/statics";
import { saveFile } from "../context/fileReducer";
import { useDispatch, useSelector } from 'react-redux';

export const useDrawFile = () => {
    const fileDetails = useSelector(state => state.fileDetails);
    const file = useSelector(state => state.file);
    const dispatch = useDispatch();


    const sortByTz = () => {
        const newData = [...file];
        newData.sort((a, b) => a[id] - b[id]);
        dispatch(saveFile(newData));
    }

    const sortByName = () => {
        const newData = [...file];
        newData.sort((a, b) => {
            const nameA = b[last_name]?.toUpperCase();
            const nameB = a[last_name]?.toUpperCase();
            if (nameA < nameB) {
                return 1;
            }
            if (nameA > nameB) {
                return -1;
            }
            return 0;
        });
        dispatch(saveFile(newData));
    }


    const removeLine = () => {
        const newData = [...file];
        newData.splice(fileDetails.currentIndex, 1);
        dispatch(saveFile(newData));
    }

    const getRemoveText = () => {
        const index = fileDetails.currentIndex
        const firstName = file?.[index]?.[first_name]
        const lastName = file?.[index]?.[last_name]
        const hasName = (firstName && String(firstName).trim() !== '') || (lastName && String(lastName).trim() !== '');
        const displayName = hasName ? `${firstName ?? ''} ${lastName ?? ''}`.trim() : 'השורה';

        return "האם אתה בטוח כי ברצונך למחוק את " + displayName + "?";
    }

    const getClassName = (row) => {
        if (row[comments] !== undefined && row[comments] !== "מנוי נוסף בהצלחה") {
            return "table-danger"
        }
        if (row[comments] === "מנוי נוסף בהצלחה") {
            return "table-success"
        }
        return ""
    }

    return { removeLine, getClassName, getRemoveText, sortByTz, sortByName }
}
